import gql from 'graphql-tag';

// Query used to get the create a LavuPay account in PAPI
export const createLavuPayAccount = gql`
	mutation createLavuPayAccount($input: LavuPayAccountInput) {
		createLavuPayAccount(input: $input) {
			uuid
			tenantId
			tenantName
		}
	}
`;

export const deleteLavuPayAccount = gql`
	mutation deleteLavuPayAccount {
		deleteLavuPayAccount
	}
`;

export const getLavuPayAccount = gql`
	query lavuPayAccount {
		lavuPayAccount {
			uuid
			tenantId
			tenantName
			locationPaymentGateways {
				uuid
				isDefault
				gatewayName
			}
		}
	}
`;

// Query used to retrieve list of cardconnect terminals
export const listLavuPayTerminals = gql`
	query lavuPayTerminals {
		lavuPayTerminals {
			accountId
			terminalId
			terminalName
			deviceType
		}
	}
`;

// Mutation used to update a cardconnect Terminal in PAPI
export const updateLavuPayTerminal = gql`
	mutation updateLavuPayTerminal($input: LavuPayTerminalInput) {
		updateLavuPayTerminal(input: $input) {
			terminalId
			terminalName
			deviceType
		}
	}
`;

export default {
	createLavuPayAccount,
	deleteLavuPayAccount,
	getLavuPayAccount,
	listLavuPayTerminals,
	updateLavuPayTerminal,
};
